import React, { Component } from 'react';
import { Button, Form, Input } from 'semantic-ui-react'

export class ApplicationTrackerForm extends Component {


  render() {
    const { appNumber, handleChange } = this.props;
    return (
      <Form>
        <Form.Field inline>
          <Input
            size='huge'
            value={appNumber}
            name='appNumber'
            placeholder='A-00000000'
            onChange={handleChange}
          />
          <Button onClick={() => {this.props.getApplicant(appNumber)}} size='large' style={{color: 'white', backgroundColor: '#640B18'}}>
            Submit
          </Button>
        </Form.Field>
      </Form>
    );
  }
}

export default ApplicationTrackerForm;
